import { createGlobalStyle } from 'styled-components';

const BodyBackground = createGlobalStyle<{ color: string }>`
  body {
    --introwise-body-bg-color: ${({ color }) => color};
  }
`;

export default BodyBackground;
